import styled from 'styled-components';
import { Dialog } from 'edenred-ui';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 985px !important;
    width: 985px !important;
  }
`;
